<template lang="pug">
    el-dialog(:title="title", width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="120px")
            el-card(shadow="never")
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="主办方" prop="userGroupName")
                    div.width_label {{ruleForm.userGroupName}}    
                el-form-item(label="比赛类型")
                    div.width_label(v-if="ruleForm.matchType === '1'") 分级公开赛
                    div.width_label(v-if="ruleForm.matchType === '2'") 俱乐部赛
                    div.width_label(v-if="ruleForm.matchType === '-1'") 青少年赛
                el-form-item(label="比赛项目" prop="projectType")
                    div.width_label(v-if="ruleForm.projectType === 1") 单打
                    div.width_label(v-if="ruleForm.projectType === 2") 双打
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.venueAddress}}
                br
                el-form-item(label="签位" prop="applySize")
                    div.width_label {{ruleForm.applySize}} 签
                el-form-item(label="报名时间")    
                    div.width_label {{ruleForm.matchSignStartTime}}至{{ruleForm.matchSignEndTime}}
                el-form-item(label="比赛时间")
                    div.width_label {{ruleForm.matchStartTime}} 
                el-form-item(label="最大场次" prop="maxVenue")
                    div.width_label {{ruleForm.maxVenue}}
                el-form-item(label="成赛场次" prop="establishVenue")
                    div.width_label {{ruleForm.establishVenue}}
                br
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 10") 未审核
                    div.width_label(v-if="ruleForm.matchStatus == 20") 已发布
                    div.width_label(v-if="ruleForm.matchStatus == 30") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 40") 已结束
                    div.width_label(v-if="ruleForm.matchStatus == 50") 已拒绝
                    div.width_label(v-if="ruleForm.matchStatus == 60") 报名结束
                    div.width_label(v-if="ruleForm.matchStatus == 70") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 80") 已取消
                el-form-item(label="自动退费")
                    div.width_label(v-if="ruleForm.autoRefund == 0") 否
                    div.width_label(v-if="ruleForm.autoRefund == 1") 是  
                el-form-item(label="距比赛开始时间" prop="refundTime")
                    div.width_label {{ruleForm.refundTime}}
                br    
            el-row(style="padding-bottom:15px;" :span="24")
              el-col( :md='14' :sm="14")
                div(style='float:left;display:flex')
                  el-button(@click='addCompetitonHandle(ruleForm)',type='primary') 添加
                  el-button(@click='deleteCompetitonHandle',type='danger') 删除
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(type="selection" width="50" align='center')
            el-table-column(prop='matchId',header-align='center',align='center',label='比赛ID' width="160")
            el-table-column(prop='matchName',header-align='center',align='center',label='比赛名称' width="150")
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方')
            el-table-column(prop='ctType',header-align='center',align='center',label='比赛类型' width="90" )
                template(slot-scope='scope')
                    font(v-if='scope.row.ctType === 1') 常规赛
                    font(v-if='scope.row.ctType === 2') 月度赛
                    font(v-if='scope.row.ctType === 3') 季度赛
                    font(v-if='scope.row.ctType === 4') 年度总决赛
            el-table-column(prop='applySize',header-align='center',align='center',label='签位' width="60")
                template(slot-scope="scope")
                    span() {{scope.row.joinCount}}/{{scope.row.applySize}}
            el-table-column(prop='projectType',header-align='center',align='center',label='比赛项目' width="80")
                template(slot-scope='scope')
                    font(v-if='scope.row.projectType === 1') 单打
                    font(v-if='scope.row.projectType === 2') 双打
            el-table-column(prop='matchSignStartTime',header-align='center',align='center',label='报名时间' width='320')  
                template(slot-scope="scope")
                    span() {{scope.row.matchSignStartTime}}至{{scope.row.matchSignEndTime}}                  
            el-table-column(prop='matchStartTime',header-align='center',align='center',label='比赛时间' width='160')
            el-table-column(prop='refereeName',header-align='center',align='center',label='裁判'  width='100' :show-overflow-tooltip='true')
            el-table-column(prop='matchStatus',header-align='center',align='center',label='状态' width="100")
                template(slot-scope="scope")
                    font(v-if='scope.row.matchStatus === 1' )
                      span.danger()
                      span() &nbsp; 未审核
                    font(v-if='scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()>new Date().getTime()')
                      span.success()
                      span() &nbsp; 已发布
                    font(v-if='scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount<scope.row.applySize')
                      span.warning()
                      span() &nbsp; 报名中
                    font(v-if='scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount>=scope.row.applySize && scope.row.bench==1')
                      span.warning()
                      span() &nbsp; 报满可替
                    font(v-if='scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount>=scope.row.applySize && scope.row.bench==0')
                      span.warning()
                      span() &nbsp; 已报满
                    font(v-if='scope.row.matchStatus === 2 && new Date().getTime()>new Date(scope.row.matchSignEndTime).getTime() &&  new Date().getTime()<new Date(scope.row.matchStartTime).getTime()')
                      span.warning()
                      span() &nbsp; 报名结束
                    font(v-if='scope.row.matchStatus === 2 &&  new Date().getTime()>new Date(scope.row.matchStartTime).getTime()')
                      span.warning()
                      span() &nbsp; 已开赛
                    font(v-if='scope.row.matchStatus === 3')
                      span.warning()
                      span() &nbsp; 已取消
                    font(v-if='scope.row.matchStatus === 4')
                      span.warning()
                      span() &nbsp; 已结束
                    font(v-if='scope.row.matchStatus === 5')
                      span.warning()
                      span() &nbsp; 已拒绝
            el-table-column(prop='recommend',header-align='center',align='center',label='首页推荐' width="100")
                template(slot-scope='scope')
                    font(v-if='scope.row.recommend == 0') 未推荐
                    font(v-if='scope.row.recommend == 1') 已推荐
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="queryHandle(scope.row)" v-if="isAuth('ct:level:info')" ) 查看详情
                                el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.matchType, scope.row.id,1)" v-if="isAuth('ct:level:update') && (scope.row.matchStatus === 1 || scope.row.matchStatus === 5)"  type="text" ) 修改比赛
                                el-menu-item(index="1-3" @click='releaseClick(1,scope.row)' v-if="isAuth('ct:level:apply') && scope.row.matchStatus === 1" type='primary') 审核发布
                                el-menu-item(index="1-4" @click='releaseClick(2,scope.row)' v-if="isAuth('ct:level:meber') && (scope.row.matchStatus === 2 || scope.row.matchStatus === 4)" type='primary') 参赛人员设置

                                el-menu-item(index="1-5" @click='releaseClick(3,scope.row)' v-if="isAuth('ct:level:referee') && (scope.row.matchStatus === 1 || scope.row.matchStatus === 2)" type='primary') 裁判设置
                                el-menu-item(index="1-6" @click='releaseClick(4,scope.row)' v-if="isAuth('ct:level:score') && (scope.row.matchStatus === 2 || scope.row.matchStatus === 4) " type='primary') 成绩管理
                                el-menu-item(index="1-7" @click='releaseClick(6,scope.row)' v-if="isAuth('ct:level:out') && scope.row.matchStatus === 2" type='primary') 取消比赛
                                el-menu-item(index="1-8" @click='releaseClick(7,scope.row)' v-if="isAuth('ct:level:over') && scope.row.matchStatus === 2" type='primary') 结束比赛
                                el-menu-item(index="1-9" @click='releaseClick(5,scope.row)' v-if="isAuth('ct:level:copy')" type='primary') 复制并新建
                                //- el-menu-item(index="1-10" @click='releaseClick(8,scope.row)' v-if="isAuth('') && scope.row.matchStatus === 2 ") 调整赛制
                                el-menu-item(index="1-10" @click='releaseClick(9,scope.row)'  v-if="isAuth('ct:level:manager') && scope.row.matchStatus !== 1 && scope.row.matchStatus !== 5 && scope.row.matchType != -1" type='primary') 场地管理
                                el-menu-item(index="1-10" @click='recommend(scope.row.id,1)' type='primary'  v-if="scope.row.recommend == 0" ) 推荐
                                el-menu-item(index="1-11" @click='recommend(scope.row.id,0)' type='primary'  v-if="scope.row.recommend == 1" ) 取消推荐

        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        updateCompetition(v-if='updateCompetitionVisible', ref="updateCompetition",@refreshDataList='getDataList')
        //添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
        //俱乐部添加和修改
        addOrUpdateClub(v-if='addOrUpdateClubVisible', ref="addOrUpdateClub",@refreshDataList='getDataList')
        //青少年添加和修改
        addOrUpdateTeen(v-if='addOrUpdateTeenVisible', ref="addOrUpdateTeen",@refreshDataList='getDataList')
        //查看和审核
        queryView(v-if='queryViewVisible', ref="queryView",@refreshDataList='getDataList')
        //查看和审核
        queryViewClub(v-if='queryViewClubVisible', ref="queryViewClub",@refreshDataList='getDataList')
        //查看和审核
        queryViewTeen(v-if='queryViewTeenVisible', ref="queryViewTeen",@refreshDataList='getDataList')
        //查看和审核
        queryViewClub(v-if='queryViewClubVisible', ref="queryViewClub",@refreshDataList='getDataList')
        //参数人员管理-单打
        elEnrollInfo(v-if='elEnrollInfoVisible',ref="elEnrollInfo",@refreshDataList='getDataList')
        //- 兼容旧数据
        elEnrollInfoOld(v-if='elEnrollInfoOldVisible',ref="elEnrollInfoOld",@refreshDataList='getDataList')
        //俱乐部参数人员管理--双打
        elEnrollInfoDouble(v-if='elEnrollInfoDoubleVisible',ref="elEnrollInfoDouble",@refreshDataList='getDataList')
        //- 兼容旧数据
        elEnrollInfoDoubleOld(v-if='elEnrollInfoDoubleOldVisible',ref="elEnrollInfoDoubleOld",@refreshDataList='getDataList')

        //俱乐部参数人员管理
        el-enroll-infoOldClub(v-if='elEnrollInfoOldClubVisible',ref="elEnrollInfoOldClub",@refreshDataList='getDataList')
        elEnrollInfoClub(v-if='elEnrollInfoClubVisible',ref="elEnrollInfoClub",@refreshDataList='getDataList')
        
        //青少年参数人员管理-单打
        elEnrollInfoTeen(v-if='elEnrollInfoTeenVisible',ref="elEnrollInfoTeen",@refreshDataList='getDataList')
        elEnrollInfoOldTeen(v-if='elEnrollInfoOldTeenVisible',ref="elEnrollInfoOldTeen",@refreshDataList='getDataList')
        //青少年参数人员管理--双打
        elEnrollInfoDoubleTeen(v-if='elEnrollInfoDoubleTeenVisible',ref="elEnrollInfoDoubleTeen",@refreshDataList='getDataList')
        elEnrollInfoDoubleOldTeen(v-if='elEnrollInfoDoubleOldTeenVisible',ref="elEnrollInfoDoubleOldTeen",@refreshDataList='getDataList')

        //安排裁判
        updateReferee(v-if='updateRefereeVisible',ref="updateReferee",@refreshDataList='getDataList')
        //安排裁判 俱乐部
        updateRefereeClub(v-if='updateRefereeVisibleClub',ref="updateRefereeClub",@refreshDataList='getDataList')
        //安排裁判 青少年
        updateRefereeTeen(v-if='updateRefereeVisibleTeen',ref="updateRefereeTeen",@refreshDataList='getDataList')

        //成绩管理-单打 分级公开赛
        gradeInfo(v-if='gradeInfoVisible' ref="gradeInfo" @refreshDataList='getDataList')
        //- 兼容旧数据 分级公开赛
        gradeInfoOld(v-if='gradeInfoOldVisible' ref="gradeInfoOld" @refreshDataList='getDataList')
        //成绩管理-双打 分级公开赛
        gradeInfoDouble(v-if='gradeInfoDoubleVisible' ref="gradeInfoDouble" @refreshDataList='getDataList')
        //- 兼容旧数据 分级公开赛
        gradeInfoDoubleOld(v-if='gradeInfoDoubleOldVisible' ref="gradeInfoDoubleOld" @refreshDataList='getDataList')

        //成绩管理 俱乐部比赛
        gradeInfoClub(v-if='gradeInfoVisibleClub' ref="gradeInfoClub" @refreshDataList='getDataList')
        gradeInfoOldClub(v-if='gradeInfoOldVisibleClub' ref="gradeInfoOldClub" @refreshDataList='getDataList')

        //成绩管理-单打 青少年比赛
        gradeInfoTeen(v-if='gradeInfoVisibleTeen' ref="gradeInfoTeen" @refreshDataList='getDataList')
        gradeInfoOldTeen(v-if='gradeInfoOldVisibleTeen' ref="gradeInfoOldTeen" @refreshDataList='getDataList')
        //成绩管理-双打 青少年比赛
        gradeInfoDoubleTeen(v-if='gradeInfoDoubleVisibleTeen' ref="gradeInfoDoubleTeen" @refreshDataList='getDataList')
        gradeInfoDoubleOldTeen(v-if='gradeInfoDoubleOldVisibleTeen' ref="gradeInfoDoubleOldTeen" @refreshDataList='getDataList')

        // 调整赛制 分级公开赛
        adjustGameSys(v-if='adjustGameSysVisible' ref="adjustGame" @refreshDataList='getDataList')
        // 调整赛制 俱乐部赛
        adjustGameSysClub(v-if='adjustGameSysVisibleClub' ref="adjustGameClub" @refreshDataList='getDataList')
        // 调整赛制 青少年赛
        adjustGameSysTeen(v-if='adjustGameSysVisibleTeen' ref="adjustGameTeen" @refreshDataList='getDataList')

        // 场地管理 分级公开赛
        siteDeploy(v-if='siteDeployVisible' ref="siteDeploy")
        // 场地管理 分级公开赛
        siteDeployClub(v-if='siteDeployVisibleClub' ref="siteDeployClub")

</template>
<script>
import table from "./table.js";
import AddOrUpdate from "../level/add-or-update";
import AddOrUpdateClub from "../club/add-or-update";
import AddOrUpdateTeen from "../teenagers/add-or-update";
import QueryView from "../level/query-view";
import QueryViewClub from "../club/query-view";
import QueryViewTeen from "../teenagers/query-view";
import ElEnrollInfo from "../level/el-enroll-info";
import ElEnrollInfoOld from "../level/el-enroll-infoOld";
import ElEnrollInfoDouble from "../level/el-enroll-info-double";
import ElEnrollInfoDoubleOld from "../level/el-enroll-info-doubleOld";
import ElEnrollInfoClub from '../club/el-enroll-info'
import ElEnrollInfoOldClub from '../club/el-enroll-infoOld'
import ElEnrollInfoTeen from '../teenagers/el-enroll-info'
import ElEnrollInfoOldTeen from '../teenagers/el-enroll-infoOld'
import ElEnrollInfoDoubleTeen from '../teenagers/el-enroll-info-double'
import ElEnrollInfoDoubleOldTeen from '../teenagers/el-enroll-info-doubleOld'
import UpdateCompetition from "./update-competition";
import UpdateReferee from '../level/update-referee'
import UpdateRefereeClub from '../club/update-referee'
import UpdateRefereeTeen from '../teenagers/update-referee'
import GradeInfo from '../level/grade-info'
import GradeInfoOld from '../level/grade-infoOld'
import GradeInfoDouble from '../level/grade-info-double'
import GradeInfoDoubleOld from '../level/grade-info-doubleOld'
import GradeInfoClub from '../club/grade-info'
import GradeInfoOldClub from '../club/grade-infoOld'
import GradeInfoTeen from '../teenagers/grade-info'
import GradeInfoOldTeen from '../teenagers/grade-infoOld'
import GradeInfoDoubleTeen from '../teenagers/grade-info-double'
import GradeInfoDoubleOldTeen from '../teenagers/grade-info-doubleOld'
import AdjustGameSys from '../level/adjust-game-sys'
import AdjustGameSysClub from '../club/adjust-game-sys'
import AdjustGameSysTeen from '../teenagers/adjust-game-sys'
import siteDeploy from '../level/site-deploy.vue'
import siteDeployClub from '../club/site-deploy.vue'
export default {
  components: {
    AddOrUpdate,
    AddOrUpdateClub,
    AddOrUpdateTeen,
    QueryView,
    ElEnrollInfo,
    ElEnrollInfoOld,
    ElEnrollInfoDouble,
    ElEnrollInfoDoubleOld,
    UpdateCompetition,
    QueryViewClub,
    QueryViewTeen,
    ElEnrollInfoClub,
    ElEnrollInfoOldClub,
    ElEnrollInfoTeen,
    ElEnrollInfoOldTeen,
    ElEnrollInfoDoubleTeen,
    ElEnrollInfoDoubleOldTeen,
    UpdateReferee,
    UpdateRefereeClub,
    UpdateRefereeTeen,
    GradeInfo,
    GradeInfoOld,
    GradeInfoDouble,
    GradeInfoDoubleOld,
    GradeInfoClub,
    GradeInfoOldClub,
    GradeInfoTeen,
    GradeInfoOldTeen,
    GradeInfoDoubleTeen,
    GradeInfoDoubleOldTeen,
    AdjustGameSys,
    AdjustGameSysClub,
    AdjustGameSysTeen,
    siteDeploy,
    siteDeployClub
  },
  data() {
    return {
      isCollapse: true,
      table: {
        columns: table.columns,
        data: null,
        size: "mini",
        stripe: true,
        border: true,
      },
      SortFormatrVisible: false,
      SortNumberVisible: false,
      argueVisible: false,
      addOrViewArgue: true,
      refundBtn: false,
      argueTitle: "",
      argueForm: {
        argue: "",
      },
      refundList: [],
      regMember: "", //注册会员
      initMember: "", //初始化会员
      honour: "", //荣誉会员
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      memberName: "",
      buttonSize: "large",
      options: [],
      value: "",
      leftData: [],
      rightData: [], // 右边列表
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      visible: false,
      addVisible: false,
      refundVisible: false,
      title: "比赛关联设置",
      enrollData: [],
      enrollDataOne: [],
      enrollDataTwo: [],
      enrollDataChange: [],
      enrollDataOneChange: [],
      enrollDataTwoChange: [],
      ruleForm: {
        id: "",
        ctId: "",
        matchName: "",
        orgId: "",
        city: "",
        province: "",
        placeId: "",
        ctType: "",
        applySize: "",
        projectType: null,
        level: "",
        bench: "1",
        applyDate: [],
        matchSignStartTime: "",
        matchSignEndTime: "",
        matchStartTime: "",
        imgList: "",
        gameDescription: "",
        matchDescription: "",
        imgDetailList: "",
        repeatSign: "0",
        genderLimit: "2",
        ageLimit: "",
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: "",
        ctRefundList: [],
        byx1: "",
        verifyReason: "",
        orderForm: 1,
      },
      enrollList: {
        ctId: "",
        bench: "0", //是否替补队员 0:否 1:是
        matchType: 1, //业务类型（1分级赛、2俱乐部）,
        mbMemberList: [],
      },
      payRefund: null,
      refundForm: {
        refundScale: undefined,
        refundFee: undefined,
      },
      radio: undefined,
      loading: null,
      refundFeeMax: 0,
      refoundDescr: "", // 退款说明
      tableData: [], // 对阵表数据
      playUsers: [], // 对阵人员
      isActive: 0, // 动态显示按钮颜色
      dataListLoading: false,
      addOrUpdateVisible: false,
      addOrUpdateClubVisible: false,
      addOrUpdateTeenVisible: false,
      queryViewVisible: false,
      queryViewClubVisible: false,
      queryViewTeenVisible: false,
      elEnrollInfoVisible: false,
      elEnrollInfoOldVisible: false,
      elEnrollInfoDoubleVisible: false,
      elEnrollInfoDoubleOldVisible: false,
      elEnrollInfoOldClubVisible: false,
      elEnrollInfoClubVisible: false,
      updateCompetitionVisible: false,
      elEnrollInfoTeenVisible: false,
      elEnrollInfoOldTeenVisible: false,
      elEnrollInfoDoubleTeenVisible: false,
      elEnrollInfoDoubleOldTeenVisible: false,
      updateRefereeVisible: false,
      updateRefereeVisibleClub: false,
      updateRefereeVisibleTeen: false,
      gradeInfoVisible: false,
      gradeInfoOldVisible: false,
      gradeInfoDoubleVisible: false,
      gradeInfoDoubleOldVisible: false,
      gradeInfoVisibleClub: false,
      gradeInfoOldVisibleClub: false,
      gradeInfoVisibleTeen: false,
      gradeInfoOldVisibleTeen: false,
      gradeInfoDoubleVisibleTeen: false,
      gradeInfoDoubleOldVisibleTeen: false,
      adjustGameSysVisible: false, // 调整赛制模态框
      adjustGameSysVisibleClub: false, // 调整赛制模态框 俱乐部比赛
      adjustGameSysVisibleTeen: false, // 调整赛制模态框 青少年比赛
      siteDeployVisible: false,
      siteDeployVisibleClub: false,
      selChangeData: [],
      row: null
    };
  },
  methods: {
    //推荐或取消推荐
    recommend (id, type) {
      let tips = type == 0 ? '确定取消推荐？' : '确定推荐？'
      let param = {
        id: id,
        recommend: type == 0 ? 0 : 1
      }
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/ctCompetition/updateRecommend'),
          method: 'post',
          data: param
        }).then(e => {
          if (e.code === 0) {
            this.$message.success('操作成功！')
            this.getDataList()
          }
        })
      }).catch(() => {
        this.$message.info('已取消！')
      })
    },
    // 调整序列号
    openSortNumber() {
      this.SortNumberVisible = true;
      this.$nextTick(() => {
        this.$refs.SortBmber.init(
          this.enrollDataOne,
          this.ruleForm.id,
          this.ruleForm.projectType
        );
      });
    },

    choseSortBmber() {
      this.SortNumberVisible = false;
    },
    // 调整赛制
    openSortFormatr() {
      this.SortFormatrVisible = true;
      this.$nextTick(() => {
        this.$refs.SortFormatr.init();
      });
    },
    // 合并单元格
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    //刷新添加人员左边table
    getLeftData() {
      let arrId = [];
      for (let i of this.enrollData) {
        arrId.push(i.mbId);
      }
      for (let i of this.rightData) {
        arrId.push(i.id);
        console.log(i.id);
      }
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getMemberList`),
        method: "post",
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.memberName,
          status: 1, //只查询已实名认证的会员
          ids: arrId.join(),
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.list.rows;
          this.totalPage = data.list.total;
        } else {
          this.leftData = [];
          this.totalPage = 0;
        }
      });
    },
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    //添加人员入库
    addEnroll() {
      if (this.rightData.length === 0) {
        this.$message.error("没有要添加的会员!");
      } else if (this.rightData.length > 0) {
        this.openFullScreen();
        this.enrollList.mbMemberList = [];
        this.rightData.forEach((data) => {
          let orderFee = "";
          if (data.type === 1) {
            orderFee = this.regMember;
          } else if (data.type === 2) {
            orderFee = this.initMember;
          } else if (data.type === 3) {
            orderFee = this.honour;
          }
          this.enrollList.mbMemberList.push({
            id: data.id,
            name: data.name,
            type: data.type,
            orderFee: orderFee,
            level: data.level,
          });
        });

        //先验证每个会员是否满足当前赛事报名条件
        this.$http({
          url: this.$http.adornUrl(`/elEnroll/checkEnrollMember`),
          method: "post",
          data: this.enrollList,
        }).then((data) => {
          console.log(data);
          if (data && data.code === 0) {
            if (data.state) {
              console.log("验证通过");
              this.$http({
                url: this.$http.adornUrl(`/elEnroll/save`),
                method: "post",
                data: this.enrollList,
              }).then((data) => {
                console.log(data);
                if (data && data.code === 0) {
                  this.$message.success("添加成功!");
                  this.addVisible = false;
                  this.init(this.ruleForm.id);
                } else {
                  this.$message.success("添加失败!");
                }
                this.loading.close();
              });
            } else {
              this.$message.error(data.info);
            }
          }
          this.loading.close();
        });
      }
    },
    initEnrollDataChange() {
      this.enrollDataChange = [];
      if (
        this.enrollDataOneChange.length === 0 &&
        this.enrollDataTwoChange.length === 0
      ) {
        this.$message.error("提示：请勾选要操作的人员！");
        return true;
      }
      this.enrollDataChange = this.enrollDataOneChange.concat(
        this.enrollDataTwoChange
      );
      console.log(this.enrollDataChange, 555);

      return false;
    },
    //初始化记录争议弹框
    initDiaLogArgue(row, val) {
      this.argueVisible = true;
      this.argueForm.id = "";
      if (val === 1) {
        this.argueForm.argue = row.argue || "";
        this.addOrViewArgue = true;
        this.argueTitle = "记录争议内容";
        this.argueForm.id = row.enrollId;
      } else {
        this.argueForm.argue = row.argue || "无争议!";
        this.addOrViewArgue = false;
        this.argueTitle = "查看争议";
      }
    },
    //记录争议提交事件
    comfirmArgue() {
      // if (this.argueForm.argue.length === 0) {
      //     this.$message.error('争议内容不能为空！')
      //     return
      // }
      if (this.argueForm.argue.length > 500) {
        this.$message.error("争议内容长度不能超过500个字符");
        return;
      }
      this.$http({
        url: this.$http.adornUrl(`/elEnroll/update`),
        method: "post",
        data: this.argueForm,
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success("操作成功！");
          this.argueVisible = false;
          this.init(this.ruleForm.id);
        }
      });
    },
    //1:审核发布 2:设置参数人数
    releaseClick(type, rows) {
      if (type == 1 ||
        type == 2 ||
        type == 3 ||
        type == 4 ||
        type == 6 ||
        type == 7 ||
        type === 8 // 调整赛制功能
        ) {
          if (rows.matchStatus === 1 && type != 1 && type != 3 && type != 5) {
          this.$message.error('比赛尚未发布!')
          return
        }
        //若比赛处在未审核、已拒绝状态（即未发布），此处提示为比赛尚未发布，不能通过此操作取消比赛。
        //已拒绝的赛事可以审核发布、裁判设置、复制并新建
        if (rows.matchStatus === 5 && type != 1 && type != 3 && type != 5) {
          this.$message.error('比赛尚未发布!')
          return
        }

        //已发布的赛事不能审核发布
        if (rows.matchStatus === 2 && type == 1) {
          this.$message.error('比赛已发布!')
          return
        }
        //已取消的比赛可以复制并新建
        if (rows.matchStatus === 3 && type != 5) {
          this.$message.error('比赛已取消!')
          return
        }
        //已结束的比赛可以录入成绩
        if (rows.matchStatus === 4 && type != 2 && type != 4) {
          this.$message.error('比赛已结束!')
          return
        }
      }
      //审核发布
      if (type == 1) {
        this.queryHandle(rows, "release");
        return;
      }
      //设置关联比赛
      if (type == 2) {
        // alert(rows.newCompetition)
        this.enrollClick(rows);
      }
      //安排裁判
      if (type == 3) {
        if(rows.matchType == 1) {
          this.updateRefereeVisible = true
          this.$nextTick(() => {
            this.$refs.updateReferee.init(rows)
          })
        }else if(rows.matchType == 2) {
          this.updateRefereeVisibleClub = true
          this.$nextTick(() => {
            this.$refs.updateRefereeClub.init(rows)
          })
        }else if(rows.matchType == -1) {
          this.updateRefereeVisibleTeen = true
          this.$nextTick(() => {
            this.$refs.updateRefereeTeen.init(rows)
          })
        }
        
      }
      //成绩管理
      if (type == 4) {
        if(rows.matchType == 1) {
          //报名结束、已开赛、已结束状态的比赛才可以进行成绩录入，否则名单显示不完整。
        if (rows.matchStatus === 2 || rows.matchStatus === 4) {
          let date1 = new Date()
          let date3 = new Date(rows.matchSignEndTime)
          if (date3.getTime() > date1.getTime()) {
            this.$message.error('报名尚未结束!')
            return
          }
          if (rows.projectType == 1) {
            //单打
            //- 兼容旧数据newCompetition==1是新数据，反之是老数据
            if (rows.newCompetition == 1) {
              this.gradeInfoVisible = true
              this.$nextTick(() => {
                this.$refs.gradeInfo.init(rows, -1)
              })
            } else {
              this.gradeInfoOldVisible = true
              this.$nextTick(() => {
                this.$refs.gradeInfoOld.init(rows, -1)
              })
            }
          } else {
            //双打
            if (rows.newCompetition == 1) {
              this.gradeInfoDoubleVisible = true
              this.$nextTick(() => {
                this.$refs.gradeInfoDouble.init(rows, -1)
              })
            } else {
              this.gradeInfoDoubleOldVisible = true
              this.$nextTick(() => {
                this.$refs.gradeInfoDoubleOld.init(rows, -1)
              })
            }
          }
        }
        } else if(rows.matchType == 2) {
          //报名结束、已开赛、已结束状态的比赛才可以进行成绩录入，否则名单显示不完整。
        if (rows.matchStatus === 2 || rows.matchStatus === 4) {
          let date1 = new Date()
          let date3 = new Date(rows.matchSignEndTime)
          if (date3.getTime() > date1.getTime()) {
            this.$message.error('报名尚未结束!')
            return
          }
          //单打
          //- 兼容旧数据newCompetition==1是新数据，反之是老数据
          if (rows.newCompetition == 1) {
            this.gradeInfoVisibleClub = true
            this.$nextTick(() => {
              this.$refs.gradeInfoClub.init(rows, -1)
            })
          } else {
            this.gradeInfoOldVisibleClub = true
            this.$nextTick(() => { this.$refs.gradeInfoOldClub.init(rows, -1) })
          }

          // this.gradeInfoVisible = true
          // this.$nextTick(() => {
          //   this.$refs.gradeInfo.init(rows, -1)
          // })
        }
        }else if(rows.matchType == -1) {
          //报名结束、已开赛、已结束状态的比赛才可以进行成绩录入，否则名单显示不完整。
        if (rows.matchStatus === 2 || rows.matchStatus === 4) {
          let date1 = new Date()
          let date3 = new Date(rows.matchSignEndTime)
          if (date3.getTime() > date1.getTime()) {
            this.$message.error('报名尚未结束!')
            return
          }
          if (rows.projectType == 1) {
            //单打
            //- 兼容旧数据newCompetition==1是新数据，反之是老数据
            if (rows.newCompetition == 1) {
              this.gradeInfoVisibleTeen = true
              this.$nextTick(() => {
                this.$refs.gradeInfoTeen.init(rows, -1)
              })
            } else {
              this.gradeInfoOldVisibleTeen = true
              this.$nextTick(() => {
                this.$refs.gradeInfoOldTeen.init(rows, -1)
              })
            }
          } else {
            //双打
            if (rows.newCompetition == 1) {
              this.gradeInfoDoubleVisibleTeen = true
              this.$nextTick(() => {
                this.$refs.gradeInfoDoubleTeen.init(rows, -1)
              })
            } else {
              this.gradeInfoDoubleOldVisibleTeen = true
              this.$nextTick(() => {
                this.$refs.gradeInfoDoubleOldTeen.init(rows, -1)
              })
            }
          }
        }
        }
        
        return
      }
      //复制新建
      if (type == 5) {
        this.openFullScreen()
        console.log(rows.id)
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/copyAdd/` + rows.id),
          method: 'post'
        }).then((data) => {
          // if (data && data.code === 0) {
          //   this.getDataList();
          //   this.$message.success("操作成功!");
          // } else {
          //   this.$message.error("添加失败!");
          // }
          this.loading.close()
          this.addOrUpdateHandle(rows.matchType, data.id, 2)
        })
      }
      //取消比赛
      if (type == 6) {
        this.$http({
          url: this.$http.adornUrl(`/elEnrollOrder/getByCtId`),
          method: 'post',
          params: this.$http.adornParams({
            ctId: rows.id
          })
        }).then((data) => {
          if (data && data.code === 0) {
            var flag = true
            for (let i of data.list) {
              if (
                i.payStatus == 2 ||
                i.payStatus == 5 ||
                i.payStatus == 6 ||
                i.payStatus == 10
              ) {
                this.$message.error('请先完成退费操作!')
                flag = false
                return
              }
            }
            let info = '是否取消比赛？'
            if (data.prePay) {
              info = '是否取消比赛，并退回加盟费至原账户？'
            }
            if (flag) {
              this.$confirm(info, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(async () => {
                  this.$http({
                    url: this.$http.adornUrl(
                      `/ctCompetition/cancelCompetition`
                    ),
                    method: 'post',
                    data: rows
                  }).then((data) => {
                    console.log('data:', data)
                    if (data && data.code === 0) {
                      if (data.state) {
                        this.getDataList()
                        this.$message.success('比赛已取消')
                      } else {
                        this.$message.error(data.info)
                      }
                    }
                  })
                })
                .catch(() => {
                  this.$message.info('已取消')
                })
            }
          }
        })
      }
      if (type == 7) {
        console.log('结束比赛操作')
        //结束比赛
        let date1 = new Date()
        let date2 = new Date(rows.matchStartTime)
        if (date2.getTime() > date1.getTime()) {
          this.$message.error('比赛尚未开始!')
          return
        }
        //若比赛处在已开赛状态，且未完成成绩录入（即成绩录入表中存在空值），则提示尚未录入成绩，不能通过此操作结束比赛。
        this.$http({
          url: this.$http.adornUrl(`/elEnroll/getByCtId`),
          method: 'post',
          params: this.$http.adornParams({
            ctId: rows.id
          })
        }).then((data) => {
          if (data.elEnrollNum == data.ctScoreNum) {
            this.$confirm('是否结束比赛？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(async () => {
                this.$http({
                  url: this.$http.adornUrl(`/ctCompetition/endCompetition`),
                  method: 'post',
                  data: rows
                }).then((data) => {
                  if (data && data.code === 0) {
                    this.getDataList()
                    this.$message.success('操作成功')
                  }
                })
              })
              .catch(() => {
                this.$message.info('操作取消')
              })
          } else {
            this.$message.error('尚未录入成绩，不能通过此操作结束比赛')
          }
        })
      }
      // 调整赛制
      if (type === 8) {
        if(rows.matchType == 1) {
          this.adjustGameSysVisible = true
          this.$nextTick(() => {
            this.$refs.adjustGame.init(rows)
          })
        } else if(rows.matchType == 2){
          this.adjustGameSysVisibleClub = true
          this.$nextTick(() => {
            this.$refs.adjustGameClub.init(rows)
          })
        } else if(rows.matchType == -1){
          this.adjustGameSysVisibleTeen = true
          this.$nextTick(() => {
            this.$refs.adjustGameTeen.init(rows)
          })
        }
        
      }
      // 场地管理
      if (type === 9) {
        if(rows.matchType == 1) {
          this.siteDeployVisible = true
          this.$nextTick(() => { 
            this.$refs.siteDeploy.init(rows)
          })
        } else if(rows.matchType == 2) {
          this.siteDeployVisibleClub = true
          this.$nextTick(() => { 
            this.$refs.siteDeployClub.init(rows)
          })
        }
        
      }
    },
     //参赛人员管理
     enrollClick (row, projectType, newCompetition) {
      console.log(row)
      if(row.matchType == 1 ){
        if (projectType == 1) {
        //- 兼容旧数据newCompetition==1是新数据，反之是老数据
        if (newCompetition == 1) {
          this.elEnrollInfoVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfo.init(row.id)
          })
        } else {
          this.elEnrollInfoOldVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoOld.init(row.id)
          })
        }
      } else {
        if (newCompetition == 1) {
          this.elEnrollInfoDoubleVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoDouble.init(row.id)
          })
        } else {
          // alert(1)
          this.elEnrollInfoDoubleOldVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoDoubleOld.init(row.id)
          })
        }
      }
      }
      if(row.matchType == 2) {
        if (newCompetition == 1) {
        this.elEnrollInfoClubVisible = true
        this.$nextTick(() => { 
          this.$refs.elEnrollInfoClub.init(row.id)
        })
      } else {
        this.elEnrollInfoOldClubVisible = true
        this.$nextTick(() => {
          this.$refs.elEnrollInfoOldClub.init(row.id)
        })
      }
      }
      if(row.matchType == -1) {
        if (projectType == 1) {
        //- 兼容旧数据newCompetition==1是新数据，反之是老数据
        if (newCompetition == 1) {
          this.elEnrollInfoTeenVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoTeen.init(row.id)
          })
        } else {
          this.elEnrollInfoOldTeenVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoOldTeen.init(row.id)
          })
        }
      } else {
        if (newCompetition == 1) {
          this.elEnrollInfoDoubleTeenVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoDoubleTeen.init(row.id)
          })
        } else {
          this.elEnrollInfoDoubleOldTeenVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoDoubleOldTeen.init(row.id)
          })
        }
      }
      }
      
    },
    addCompetitonHandle(row) {
      console.log(this.selChangeData);
      // if (this.selChangeData.length <= 0) {
      //   this.$message.error("请先选择要关联的比赛!");
      //   return;
      // }
      this.updateCompetitionVisible = true;
      this.$nextTick(() => {
        this.$refs.updateCompetition.init(row, this.selChangeData);
      });
    },
    deleteCompetitonHandle() {
      if (this.selChangeData.length <= 0) {
        this.$message.error("请先选择要删除的比赛!");
        return;
      }
      console.log(this.selChangeData);
      const bindCtIds = [];
      this.selChangeData.forEach((data) => {
        bindCtIds.push(data.ctId);
      });
      console.log(this.ruleForm.id)
      this.$http({
        url: this.$http.adornUrl(
          `/ctCompetition/selfSelection/updateRelationCompetition`
        ),
        method: "post",
        data: {
          selfCtId: this.ruleForm.id,
          operateType: 20,
          bindCtIds: bindCtIds,
        },
      })
        .then((data) => {
          if (data && data.code === 0) {
            // this.visible = false;
            this.$message.success("操作成功!");
            // this.$emit("refreshDataList");
            this.getDataList()
          } else {
            this.$message.success("操作失败!");
          }
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    init(id, row) {
      this.ruleForm.id = id;
      this.row = row
      this.radio = undefined;
      this.visible = true;
      this.regMember = "";
      this.initMember = "";
      this.honour = "";
      this.enrollData = [];
      this.enrollDataOne = [];
      this.enrollDataTwo = [];
      this.enrollDataChange = [];
      this.enrollDataOneChange = [];
      this.enrollDataTwoChange = [];

      //回显
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/selfSelection/getById/` + id),
        method: "get",
      })
        .then((data) => {
          if (data && data.code === 0) {
            this.ruleForm = data.data;
            console.log("竞赛信息：", data.data);
            this.ruleForm.enrollDisabled = true;
          }
        })
        .then(() => {
          // 获取对阵表数据
          this.getDataList(id);
        });
    },
    /**
     * 与当前时间比较 返回小时
     * @param date2
     * @returns {number}
     */
    getDateDiff(date2) {
      let startDate = new Date(date2);
      let endDate = new Date();
      if (startDate.getTime() > endDate.getTime()) {
        let hour = (startDate.getTime() - endDate.getTime()) / 1000 / 60 / 60;
        return hour;
      } else {
        return -1;
      }
    },
    // 参赛人员管理-对阵表信息
    getDataList(id) {
      console.log(id);
      this.dataListLoading = true;
      let ctStrTime = null;
      let ctEndTime = null;
      if (this.ruleForm.matchStartTime !== null) {
        if (this.ruleForm.matchStartTime.length > 0) {
          ctStrTime = this.ruleForm.matchStartTime[0];
          ctEndTime = this.ruleForm.matchStartTime[1];
        }
      }

      this.$http({
        url: this.$http.adornUrl("/ctCompetition/list"),
        method: "post",
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          matchType: this.row.matchType,
          selfCtId: this.ruleForm.id,
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.page.rows;
          this.totalPage = data.page.total;
        } else {
          this.tableData = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    //查看和审核发布
    queryHandle(row, type) {
      if(row.matchType == 1) {
        this.queryViewVisible = true;
        this.$nextTick(() => {
          this.$refs.queryView.init(row.id, type);
        });
      }
      if(row.matchType == 2) {
        this.queryViewClubVisible = true;
        this.$nextTick(() => {
          this.$refs.queryViewClub.init(row.id, type);
        });
      }
      if(row.matchType == -1) {
        this.queryViewTeenVisible = true
        this.$nextTick(() => {
          this.$refs.queryViewTeen.init(row.id, type);
        });
      }
      
    },
    queryList() {
      this.pageIndex = 1;
      this.getDataList();
    },
    addCompetitionHandle() {
      // this.ruleForm.id
    },

    //添加或修改事件
    addOrUpdateHandle(matchType, id, flagType) {
      if(matchType == 1) {
        this.addOrUpdateVisible = true;
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(id, flagType);
        });
      }else if(matchType == 2) {
        this.addOrUpdateClubVisible = true;
        this.$nextTick(() => {
          this.$refs.addOrUpdateClub.init(id, flagType);
        });
      }else if(matchType == -1) {
        this.addOrUpdateTeenVisible = true;
        this.$nextTick(() => {
          this.$refs.addOrUpdateTeen.init(id, flagType);
        });
      }
      
    },
    checkAll(val) {
      this.nowSelectData = val;
    },
    checkRightAll(val) {
      this.nowSelectRightData = val;
    },
    //勾选列表事件
    selectionChangeHandle(val) {
      let choseVal = [];
      // val.
      val.forEach((item) => {
        let arr = {
          ctId: item.id,
          clubName: item.matchName,
        };
        choseVal.push(arr);
      });
      this.selChangeData = choseVal;
    },
    //操作三点
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleConcatArr(rightData, nowSelectData) {
      let arr = [];
      arr = arr.concat(rightData, nowSelectData);
      return arr;
    },
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]["name"] === originalArr[k]["name"]) {
              originalArr.splice(k, 1);
            }
          }
        }
      }
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getLeftData();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getLeftData();
    },
    //主力勾选事件
    enrollOneChange(val) {
      this.enrollDataOneChange = val;
    },
    //主力勾选事件
    enrollTwoChange(val) {
      this.enrollDataTwoChange = val;
    },
    //导出excel
    exportExcel() {
      console.log("表头：", this.table.columns);
      let exportData = [];
      console.log("表数据：", exportData);
      for (let i of this.table.data) {
        if (i.bench === 0) {
          i.genderName = { 0: "男", 1: "女" }[i.gender];
          i.memberTypeName = {
            1: "注册会员",
            2: "初始会员",
            3: "荣誉会员",
          }[i.memberType];
          i.yearScore = i.yearScore || 0;
          exportData.push(i);
        }
      }
      if (exportData == null || exportData.length === 0) {
        this.$message.info("没有要导出的数据!");
        return;
      }
      let title = this.ruleForm.matchName || "";
      this.$export
        .excel({
          columns: this.table.columns,
          data: exportData,
          title: title + "参赛人员",
        })
        .then(() => {
          this.$message.success("导出表格成功");
        });
    },
  },
};
</script>
<style>
.active {
  background: #02b90d !important;
  color: #fff !important;
}
.marginBottom {
  margin-bottom: 20px;
}
.width_label {
  width: 180px;
}
.opSetting {
  text-align: center;
  margin-top: 30px;
}
.spacing {
  margin-top: 10px;
}
.font_label {
  font-weight: bold;
  font-size: 18px;
}

.el-radio.is-bordered {
  width: 140px;
  padding: 12px 20px 0 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 40px;
}

/* 分页样式 */
.el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 20.5px;
  height: 28px;
  line-height: 28px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
.headTitle {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
